<div class="drawer-overlay" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="drawer-container" [style.width]="width" (click)="$event.stopPropagation()">
    <div class="drawer-header">
      <h5 class="drawer-title">{{ title }}</h5>
      <button type="button" class="drawer-close-btn" (click)="onClose()" aria-label="Close">
        <i class="ri-close-line"></i>
      </button>
    </div>
    <div class="drawer-body">
      <ng-content></ng-content>
    </div>
  </div>
</div>

